import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=4767adca&scoped=true&"
import script from "./Brackets.vue?vue&type=script&lang=js&"
export * from "./Brackets.vue?vue&type=script&lang=js&"
import style0 from "./Brackets.vue?vue&type=style&index=0&id=4767adca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4767adca",
  null
  
)

export default component.exports